import { render } from "./ExpensesMovementTable.vue?vue&type=template&id=70949fd5&scoped=true"
import script from "./ExpensesMovementTable.vue?vue&type=script&lang=js"
export * from "./ExpensesMovementTable.vue?vue&type=script&lang=js"

import "./ExpensesMovementTable.vue?vue&type=style&index=0&id=70949fd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70949fd5"]])

export default __exports__